import BaseModel from '../core/BaseModel'
export default class RequestActivationExpandModel extends BaseModel {
    constructor() {
        super({ 
                name: "request_activation_expand",
                tableName: 'core_request_activation'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            full_name: { 
                name: 'full_name', 
                type: "String", 
                label: 'Khách hàng',
                computed: (data) => {
                    data.full_name = (data.customer_profile !== undefined && data.customer_profile !== null) ? data.customer_profile.full_name  :  '';
                }
            },
            modified_date: { 
                name: 'modified_date', 
                type: "Date", 
                label: 'Ngày cập nhật',
                display: false,
                filter: { type: 'DateRange', match: 'custom'}
            },
            organization_id: { 
                name: 'organization_id', 
                label: 'Đơn vị cập nhật',
                class: 'center',
                display: false,
                computed: (data) => {
                    data.organization_id = (data.organizations !== undefined && data.organizations !== null) ? data.organizations.name  :  '';
                }
            },
            warrantyStatus: { 
                name: 'warrantyStatus', 
                type: "Selection",
                label: 'Trạng thái bảo hành',
                dataType: 'Label',
                class: 'center',
                options: [{style: 'color: #00CC00; font-weight: 500;'}, { value: 0, label: 'Chưa kích hoạt', style: 'color: #FF6600; font-weight: 500;'}, { value: 2, label: 'Chờ kích hoạt', style: 'color: #990099; font-weight: 500;'}, { value: 3, label: 'Đã kích hoạt', style: 'color: #00CC00; font-weight: 500;'}, { value: 4, label: 'Hết bảo hành', style: 'color: #0000CC;font-weight: 500;'},{ value: 5, label: 'Tắt kích hoạt', style: 'color: #FF6600;font-weight: 500;'}, { value: 6, label: 'Sản phẩm huỷ', style: 'color: #000000;font-weight: 500;'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals'},
                computed: (data) => {
                    if (data.request_activation_product_serial != undefined && data.request_activation_product_serial != null && Object.keys(data.request_activation_product_serial).length) {
                        //data.warrantyStatus = (data.request_activation_product_serial[0].warranty_status == 5 ) ? 0 : data.request_activation_product_serial[0].warranty_status;
                        //riêng trong lịch sử này nếu trạng thái =5 thì là tắt kích hoạt
                        data.warrantyStatus =  data.request_activation_product_serial[0].warranty_status;
                    }
                }
            },
            detail: { 
                name: 'detail', 
                type: "Text", 
                label: 'Chi tiết',
                class: 'center',
                callback: true,
                display: false,
                computed: (data) => {
                    data.detail = '<abbr class="external-link">Xem chi tiết</abbr>';
                }
            }
        },)
    }

}